import { render, staticRenderFns } from "./questionSearch.vue?vue&type=template&id=a42dd982&"
import script from "./questionSearch.vue?vue&type=script&lang=js&"
export * from "./questionSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports